class TootoSlabMatch extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.options = Array.from(this.querySelectorAll('[data-slab-option]'));
    this.activate = (event) => {
      const option = event.currentTarget.dataset.slabOption;
      if (option) this.dataset.active = option;
    };
    this.reset = () => {
      this.dataset.active = this.dataset.defaultActive || 'psa';
    };

    this.options.forEach((option) => {
      option.addEventListener('pointerenter', this.activate);
      option.addEventListener('focusin', this.activate);
    });
    this.addEventListener('pointerleave', this.reset);

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.classList.add('is-visible');
        this.observer.disconnect();
      },
      { threshold: 0.18 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.options?.forEach((option) => {
      option.removeEventListener('pointerenter', this.activate);
      option.removeEventListener('focusin', this.activate);
    });
    this.removeEventListener('pointerleave', this.reset);
    this.observer?.disconnect();
  }
}

if (!customElements.get('tooto-slab-match')) {
  customElements.define('tooto-slab-match', TootoSlabMatch);
}
